var LawLabelLinkEnum;
(function (LawLabelLinkEnum) {
    LawLabelLinkEnum["LABEL_LAW_LABEL_EN"] = "Law Label";
    LawLabelLinkEnum["LABEL_LAW_LABEL_ES"] = "Etiqueta normativa";
})(LawLabelLinkEnum || (LawLabelLinkEnum = {}));
export default LawLabelLinkEnum;
//# sourceMappingURL=LawLabelLinkEnum.js.map